<template>
  <div class="d-flex flex-column void-container">
    <div class="d-flex flex-wrap">
      <div class="mr-2">
        <b>Voided by: </b><span>{{ get(value, ['voidedBy', 'name'], '-') }}</span>
      </div>
      <div>
        <b>Voided at: </b><span>{{ value.voidedAt | moment }}</span>
      </div>
    </div>
    <div>
      <b> Refund Payment Method: </b>
      <span>{{ get(value, ['voidedPaymentMethod'], '-') }}</span>
    </div>
    <div>
      <b> Remarks: </b>
      <span>{{ get(value, ['voidedRemarks'], '-') }} </span>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
export default {
  props: {
    value: null,
  },
  methods: {
    get,
  },
};
</script>

<style lang="scss" scoped>
.void-container {
  border: thin solid red;
  border-radius: 4px;
  color: red;
  padding: 4px;
}
</style>
